module.exports = __webpack_public_path__ + "static/portfolio_gallery_23-041b5152a9f24426a3bb1ee3c76e132e.jpg";